import type { ModalConfig } from "./types";

export const dealModalsModalUrlConfig = {
  // Deal Modals
  "deals-detail": {
    modalId: "deals-detail",
    entityName: "deals",
    singularParam: "dealId",
    pluralParam: "dealsId",
    displayName: "Deal",
  },
  "create-deals": {
    modalId: "create-deals",
    entityName: "deals",
    singularParam: "dealId",
    pluralParam: "dealsId",
    displayName: "Deal",
  },
  "edit-deals": {
    modalId: "edit-deals",
    entityName: "deals",
    singularParam: "dealId",
    pluralParam: "dealsId",
    displayName: "Deal",
  },
} as const satisfies Record<string, ModalConfig>;
